import {
  AcceptInvite,
  CreateAccount,
  ForgotPassword,
  ResendVerificationLink,
  ResetPassword,
  Signin,
  VerifyAccount,
} from '@/apis/authApis'
import { useMutation } from 'react-query'

export const useCreateAccount = () => {
  return useMutation(CreateAccount)
}

export const useAcceptInvite = () => {
  return useMutation(AcceptInvite)
}
export const useVerifyAccount = () => {
  return useMutation(VerifyAccount)
}

export const useSendVerifcationLink = () => {
  return useMutation(ResendVerificationLink)
}

export const useForgotPassword = () => {
  return useMutation(ForgotPassword)
}

export const useResetPassword = () => {
  return useMutation(ResetPassword)
}
export const useSignin = () => {
  return useMutation(Signin)
}
